import { render, staticRenderFns } from "./PremiumTopMenu.vue?vue&type=template&id=0a5b8eea&scoped=true"
import script from "./PremiumTopMenu.vue?vue&type=script&lang=js"
export * from "./PremiumTopMenu.vue?vue&type=script&lang=js"
import style0 from "./PremiumTopMenu.vue?vue&type=style&index=0&id=0a5b8eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b8eea",
  null
  
)

export default component.exports